import { GridStackOptions } from 'gridstack';

export const defaultGridStackOptions: GridStackOptions = {
    float: true,
    staticGrid: true,
    cellHeight: 100
};